<template>
  <section>
    <AdminHeader :headerName="payload.shopname" :view_form="true" />
    <v-overlay :value="$store.state.overlay">
      <v-progress-circular indeterminate size="64"></v-progress-circular>
    </v-overlay>
    <div class="desktop_margin">
      <v-container class="desktopView pt-10">
        <div class="d-flex justify-space-between">
          <div class="justify-start">
            <!-- <h5 class="justify-content-start">{{payload.shopname}}</h5> -->
            <div class="justify-content-start header-desktop">
              {{ $t("newUi.forms.editForm", { form: header_name }) }}
            </div>
          </div>
          <div class="justify-end" style="font-size: 12px">
            <div class="row p-2 justify-content-end">
              <v-btn
                style="font-size: 14px"
                class="button_padding"
                color="#8AB26D"
                @click="delete_form_dialog = true"
              >
                {{ $t("newUi.editForm.deleteForm") }}
              </v-btn>
              <!-- <div class="link_heading pt-2">Your Form Link</div>
          <div class="col-4 background_color text-truncate text_color" >{{linkval}}</div>
            <span class="pt-2"><i class="bi bi-files icon_color" style="font-size: 14px; margin-bottom: 1px;" @click="doCopy"></i></span> -->
            </div>
          </div>
        </div>
      </v-container>

      <v-container v-if="item_type == ''">
        <div class="row cursor-pointer">
          <div
            class="border-bottom cursor-pointer p-2 m-2"
            :class="{ text_color: selected == 'Product' }"
            @click="selected = 'Product'"
          >
            {{ $t("newUi.adminViewform.addPro") }}
          </div>
          <div
            class="border-bottom cursor-pointer p-2 m-2"
            :class="{ text_color: selected == 'Category' }"
            @click="selected = 'Category'"
          >
            {{ $t("newUi.adminViewform.addCat") }}
          </div>
        </div>
        <AddProducts
          v-if="selected == 'Product'"
          :payload="payload"
        ></AddProducts>
        <AddCategory
          class="mt-5"
          v-if="selected == 'Category'"
          :payload="payload"
        ></AddCategory>
      </v-container>
      <v-container v-if="item_type != ''">
        <!-- <div class="row cursor-pointer">
            <div class="border-bottom p-2 m-2"  :class="{text_color: selected == 'Product'}" @click="selected = 'Product'">Add Product</div>
            <div class="border-bottom p-2 m-2" :class="{text_color: selected == 'Category'}" @click="selected = 'Category'"> Add Category</div>
        </div> -->
        <edit-products
          class="mt-5"
          v-if="item_type == 'edit_product'"
          :payload="$route.params.item_deatails"
        ></edit-products>
        <edit-category
          class="mt-5"
          v-if="item_type == 'edit_category'"
          :payload="$route.params.item_deatails"
        ></edit-category>
      </v-container>
      <v-dialog v-model="delete_form_dialog" content-class="crop-dialog">
        <v-container style="height: 200px; background-color: #fff">
          <div
            class="d-flex justify-end justify-content-end text_color"
            style="font-size: 14px"
          >
            <i class="bi bi-x" @click="delete_form_dialog = false"></i>
          </div>
          <div class="text-center text_color">
            {{ $t("newUi.editForm.deleteForm") }}
          </div>
          <v-container class="text-center">
            <div>{{ $t("newUi.deleteForm.confirmDelete") }}</div>
            <v-spacer style="padding: 10px"></v-spacer>
            <v-btn
              color="#8AB26D"
              class="button_padding"
              @click="delete_form_dialog = false"
              >{{ $t("common.cancelButton") }}</v-btn
            >
            <v-btn
              color="#8AB26D"
              class="button_padding"
              @click="deleteFormFile(payload.pos)"
              >{{ $t("common.deleteButton") }}</v-btn
            >
          </v-container>
        </v-container>
      </v-dialog>
    </div>
  </section>
</template>
<script>
import { saveFile, setLocale } from "../services/firebase";
import {
  saveMasterData,
  deleteFile,
  deleteMasterData,
} from "../services/firebase";
import store from "../store/store";
import AddProducts from "@/components/AddProducts.vue";
import AddCategory from "@/components/AddCategory.vue";
import i18n from "../i18n";
import router from "../router/router";
import AdminHeader from "@/layout/adminHeader.vue";
import EditProducts from "../components/EditProducts.vue";
import EditCategory from "../components/EditCategory.vue";
export default {
  name: "GsCatelogueEditForm",
  props: ["payload"],
  components: {
    AdminHeader,
    AddProducts,
    AddCategory,
    EditProducts,
    EditCategory,
  },
  data() {
    return {
      validateNumber: "hide",
      selected: this.$route.params.add_type
        ? this.$route.params.add_type
        : "Product",
      form_saved: false,
      phone: "",
      valid_number: "",
      item_type: this.$route.params.edit_type
        ? this.$route.params.edit_type
        : "",
      phone_valid: "",
      delete_form_dialog: false,
      // set_overlay: false,
    };
  },
  mounted() {
    setLocale();
  },
  computed: {
    header_name() {
      let name = "";
      if (this.payload.type == "Ordering form") {
        name = i18n.t("newUi.forms.order");
      } else {
        name = i18n.t("newUi.forms.cat");
      }
      return name;
    },
  },
  methods: {
    addcateg: function() {
      var p = this.$store.state.currentForm.catalogue.maxlength;
      if (!p) {
        p = 1;
        this.$store.dispatch("setMaxLength", 1);
      } else {
        var maxlength = this.$store.state.currentForm.catalogue.maxlength + 1;
        p = maxlength;
        this.$store.dispatch("setMaxLength", maxlength);
      }
      this.$store.state.currentForm.catalogue.push({
        pos: p,
        type: "category",
        name: "",
      });
    },

    onInput(formattedNumber, { number, valid }) {
      document.getElementsByClassName("vti__input").value = number;
      this.phone_valid = valid;
      this.mobile_number = formattedNumber;
      this.payload.phone = number;
    },
    onValidate: function({ valid }) {
      this.phone_valid = valid;
      // console.log(number, valid, country)
    },
    additem: function() {
      var p = this.$store.state.currentForm.catalogue.maxlength;
      if (!p) {
        p = 1;
        this.$store.dispatch("setMaxLength", 1);
      } else {
        var maxlength = this.$store.state.currentForm.catalogue.maxlength + 1;
        p = maxlength;
        this.$store.dispatch("setMaxLength", maxlength);
      }
      this.$store.state.currentForm.catalogue.push({
        pos: p,
        type: "item",
        name: "",
        desc: "",
        imageurl: "",
        price: 0,
        qtty: 0,
      });
    },
    delitem: function() {
      this.$store.state.currentForm.catalogue.pop();
    },
    submit: function() {
      this.saveCurrentForm();
    },
    cancel: function() {
      router.push("/admin/viewform/" + this.$store.state.currentForm.pos);
    },
    deleteFormFile: function(formlink) {
      //controller.pause();
      var storedata = this.$store;
      this.$store.dispatch("setOverlay", true);
      // this.set_overlay = true;
      var elethis = this;
      for (var i = 0; i < this.$store.state.forms.length; i++) {
        if (this.$store.state.forms[i].link.split("/")[3] === formlink) {
          this.$store.state.forms.splice(i, 1);
          deleteMasterData(function(err) {
            console.log(err);
            return 0;
          }, this.$store.state);
          //var pos = parseInt(formlink.split("/")[3]);
          // var pos;
          // if (formlink.split("/")[3]) {
          //   pos = parseInt(formlink.split("/")[3]);
          // } else {
          //   pos = parseInt(formlink.split("/")[2]);
          // }
          deleteFile(this.$store.state.profile.uid, formlink, function() {
            storedata.dispatch("setOverlay", false);
            // elethis.set_overlay = false;
          });
          break;
        }
      }
      router.push("/admin");
    },
    validatePhone: function(phone) {
      var regex = /^\+(?:[0-9] ?){6,14}[0-9]$/;
      if (regex.test(phone)) {
        //this.validateNumber = "hide";
        return true;
      } else {
        //this.validateNumber = "display";
        return false;
      }
    },
    validatePrice: function() {
      var catelogue = this.$store.state.currentForm.catalogue;
      var data = {
        status: true,
        price: "",
      };
      if (catelogue.length > 0) {
        for (var i = 0; i < catelogue.length; i++) {
          if (catelogue[i].type == "item") {
            if (
              catelogue[i].price == "" ||
              parseFloat(catelogue[i].price) < 0 ||
              !parseFloat(catelogue[i].price)
            ) {
              data.status = false;
              data.price = catelogue[i].price;
              return data.status;
            }
          }
        }
        return data.status;
      } else {
        return data.status;
      }
    },
    saveCurrentForm: function() {
      var shopname = this.$store.state.currentForm.shopname;
      var phone = this.$store.state.currentForm.phone;
      // this.$store.state.currentForm.createdOn = new Date()

      if (shopname == null || !shopname || shopname == "") {
        alert(i18n.t("alertText.validateNameAlert", { type: this.type }));
      } else if (phone == "+91" || this.phone_valid != true) {
        alert(i18n.t("alertText.validatePhoneAlert"));
      } else {
        this.$store.dispatch("setOverlay", true);
        saveFile(
          this.$store.state.profile.uid,
          this.$store.state.currentFormPos,
          JSON.stringify(this.$store.state.currentForm),
          function(error) {
            if (error) {
              //TODO skeleton data
              alert(i18n.t("alertText.saveFailed"));
              store.dispatch("setOverlay", false);
            } else {
              alert(i18n.t("alertText.uploadText"));
              store.dispatch("setOverlay", false);
            }
          }
        ).then(() => {
          saveMasterData(function(err) {
            console.log(err);
          }, this.$store.state);
          this.form_saved = true;
          router.push("/admin/viewform/" + store.state.currentForm.pos);
        });
      }
    },
  },
};
</script>
<style lang="scss">
.background_color {
  background-color: #f8faf7;
  padding: 20px;
  margin-bottom: 10px;
  width: 100%;
}
.button_padding {
  margin-right: 10px;
  padding: 10px;
  font-weight: bold;
  color: white !important;
  font-size: 12px;
  letter-spacing: 0px;
  text-align: center;
  text-transform: none;
  cursor: pointer;
}
input[type="text"] {
  margin-bottom: 0px;
  border: none;
  margin-top: 0px;
}
.bottom_modal {
  border-top-right-radius: 20px !important;
  border-top-left-radius: 20px !important;
  border-bottom-left-radius: 0px;
  border-bottom-right-radius: 0px;
}
.invalid_color {
  border: 1px solid red;
}
@media (min-width: 960px) {
  .desktop_margin {
    padding: 0rem 4rem;
  }
  .header-desktop {
    font-weight: bold;
    letter-spacing: 0px;
    font-size: 24px;
    color: #31333e;
  }
}
.icon_color {
  color: #8ab26d;
  justify-content: center;
  font-size: 20px;
  width: 26px;
  height: 26px;
  background-color: #f8faf7;
  padding: 5px;
  margin: 3px;
  border-radius: 3px;
}
.text_color {
  color: #8ab26d;
  font-weight: bold;
}
</style>
